module.exports = __webpack_public_path__ + "img/hr-tree-04-d-leaves.1740924c.png";